import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { studioTreeSelectTheme } from "../studioSelectTheme";
import "../../studioSelect.css";
import { NTreeSelect } from "naive-ui";
import type { TreeSelectOption } from "naive-ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestReferenceSelect',
  props: {
    options: {},
    modelValue: {},
    placeholder: {},
    disabled: { type: Boolean },
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

function update(value: unknown) {
  if (value === null || typeof value === "number") emit("update:modelValue", value);
}
function filter(pattern: string, option: TreeSelectOption) {
  return String(option.searchText ?? option.label ?? "").toLocaleLowerCase().includes(pattern.trim().toLocaleLowerCase());
}
function clickBehavior({ option }: { option: TreeSelectOption }): "toggleSelect" | "toggleExpand" {
  return typeof option.key === "number" ? "toggleSelect" : "toggleExpand";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NTreeSelect), {
    "theme-overrides": _unref(studioTreeSelectTheme),
    "menu-props": { class: 'studio-select-menu' },
    class: "quest-reference-select",
    value: __props.modelValue,
    options: __props.options,
    disabled: __props.disabled,
    "aria-label": __props.label,
    placeholder: __props.placeholder ?? '选择任务或搜索任务名 / ID',
    filterable: "",
    clearable: "",
    "show-path": "",
    "show-line": "",
    "default-expand-all": "",
    "virtual-scroll": "",
    filter: filter,
    "override-default-node-click-behavior": clickBehavior,
    "onUpdate:value": update
  }, {
    empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("没有匹配的任务", -1)
    ]))]),
    _: 1
  }, 8, ["theme-overrides", "value", "options", "disabled", "aria-label", "placeholder"]))
}
}

})